import axios from "axios";
import CommonLayout from "./CommonLayout";
import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setPage, setUserData } from "../../Redux/ActionCreater";
import { BASE_URL } from "../../config";
import { Markup } from "interweave";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../Redux/ActionCreater";
import { FaCircleCheck } from "react-icons/fa6";
import { GrLocation } from "react-icons/gr";
import { PiCurrencyInr } from "react-icons/pi";

const Profile = () => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [details, setDetails] = useState([]);
  const [countJobs, setCountJobs] = useState(2);
  const [showButton, setShowButton] = useState(true);
  dispatch(setPage("dashboard"));
  const { userData } = useSelector(
    (state) => ({
      userData: state.dataReducer.userData,
    }),
    shallowEqual
  );
  let token = localStorage.getItem("tokenData");
  const handleViewMore = () => {
    setCountJobs(jobs.length); // Set countJobs to the total number of jobs
    setShowButton(false); // Hide the "View More" button
  };
  let user = JSON.parse(localStorage.getItem("log_in_data"));
  let getJobs = async (id) => {
    try {
      await axios
        .get(`${BASE_URL}/getJobList?candidate_id=${user.candidate_id}`)
        .then((res) => {
          if (res.data.status === 200) {
            setJobs(res.data.data);
          } else if (res.data.status === 401) {
            dispatch(logout(navigate, "Please login to continue!"));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  let getDetails = async (id) => {
    try {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${BASE_URL}/getDashboardData`,
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      axios.request(config).then((response) => {
        if (response.data.status === 200) {
          setDetails(response.data.data);
        } else if (response.data.status === 401) {
          dispatch(logout(navigate, "Please login to continue!"));
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDetails();
    getJobs();
  }, []);

  return (
    <CommonLayout>
      <div className="content-wrapper">
        {/* <div className=''> */}
        <div className="page-heding dashboard-head">
          <div className="row align-items-center">
            <div className="col-sm-9">
              <h5 className="mb-2 text-titlecase mb-4 mydshbrd-heding">
                {userData.name}
              </h5>
              <p>{details.updated_profile}</p>
            </div>
            <div className="col-sm-3">
              <div class="profile-status">
                <label>Your Profile Status</label>
                <div class="progress-bar">
                  <div
                    class="progress"
                    style={{ width: `${details.profile_percentage}%` }}
                  >
                    {details.profile_percentage}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* </div> */}

        {/* {!details.profile_completed&& <div>
            <h2>Complete your profile to access job postings.</h2>
          </div>} */}

        <div class="accordion details-acordn" id="accordionExample">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Details
              </button>
            </h2>
            <div
              id="collapseOne"
              class="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div class="accordion-body">
                <div className="row">
                  <div className="col-xl-11 grid-margin stretch-card flex-column listing-list">
                    {details.notofications &&
                      details.notofications.length > 0 &&
                      details.notofications.map((item, idx) => {
                        return (
                          <h4>
                            <i>
                              <FaCircleCheck />
                            </i>{" "}
                            <Markup content={item.content} />
                          </h4>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {jobs.length > 0 &&
            jobs.slice(0, countJobs).map((item, idx) => {
              return (
                <div className="col-xl-6 grid-margin stretch-card flex-column">
                  <div className="row">
                    <div className="col-md-12 stretch-card">
                      <div className="card">
                        <div className="card-body card-bg">
                          <div className="d-flex justify-content-between align-items-start flex-wrap">
                            <div>
                              <h4 className="mb-3">{item.title}</h4>
                              {/* <h4>{item.title}</h4> */}
                              {/* <h5><i className="fa fa-ban" style={{ fontSize: 20 }} />&nbsp;Not Disclosed</h5> */}
                              <h5>
                                <i>
                                  <PiCurrencyInr />
                                </i>
                                {item.salary}
                              </h5>
                              <h5>
                                <i>
                                  <GrLocation />
                                </i>
                                &nbsp;{item.location}
                              </h5>
                            </div>
                          </div>
                          <div
                            className="add-button"
                            style={{ textAlign: "right", marginTop: 10 }}
                          >
                            <Link
                              to={"/current-opening-details/" + btoa(item.id)}
                              className="viwbtn"
                            >
                              View Details
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        {showButton && jobs.length > 2 && (
          <div
            className="add-button"
            style={{ textAlign: "right", marginBottom: 10 }}
          >
            <button onClick={handleViewMore} className="btn viwmor">
              View More
            </button>
          </div>
        )}
        {/* <hr />
        <marquee direction="left">
          <h5 className="mb-2 text-titlecase mb-4"><b>{details.updated_profile}</b></h5>
        </marquee>
        <hr /> */}
      </div>

      {/* </div> */}
    </CommonLayout>
  );
};

export default Profile;
